import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    logoUrl: "",
    userType: "",
    template: "",
  });

  /* ---------------- FETCH USER ---------------- */
  useEffect(() => {
    axios
      .get(`https://api.livestockify.com/api/admin/users/uuid/${id}`)
      .then((res) => {
        const u = res.data;

        setForm((prev) => ({
          ...prev,
          firstName: u.firstName || "",
          lastName: u.lastName || "",
          email: u.email || "",
          phoneNumber: u.phoneNumber || "",
          logoUrl: u.logoUrl || "",
          userType: u.userType || "",
          template: u.template || "",
        }));

        localStorage.setItem("editUserData", JSON.stringify(u));
      })
      .catch(console.error);
  }, [id]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleNext = () => {
    localStorage.setItem(
      "editUserData",
      JSON.stringify({ ...form, uuid: id })
    );
    navigate(`/users/edit/${id}/devices`);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      {/* MAIN CONTENT */}
      <div className="flex-1 bg-white rounded-l-2xl px-6 py-8">
        {/* STEPS HEADER */}
        <div className="flex justify-center mb-10">
          <div className="flex items-center gap-16">
            <div className="flex flex-col items-center">
              <div className="w-3 h-3 rounded-full bg-green-700 mb-2" />
              <span className="text-green-700 font-medium">Edit User</span>
            </div>

            <div className="flex flex-col items-center opacity-40">
              <div className="w-3 h-3 rounded-full bg-gray-400 mb-2" />
              <span className="font-medium">Edit Devices</span>
            </div>
          </div>
        </div>

        {/* FORM */}
        <div className="flex justify-center">
          <div className="w-full max-w-2xl">
            {[
              ["First Name", "firstName", "Enter First Name"],
              ["Last Name", "lastName", "Enter Last Name"],
              ["Email ID", "email", "Enter Email ID"],
              ["Mobile Number", "phoneNumber", "Enter Mobile Number"],
              // ["Password", "password", "Enter Password"],
              // ["Confirm Password", "confirmPassword", "Confirm Password"],
              ["Logo Url", "logoUrl", "Enter Logo URL"],
            ].map(([label, name, placeholder]) => (
              <div
                key={name}
                className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-4 mb-4 items-center"
              >
                <label className="text-sm font-medium text-gray-700 md:text-right">
                  {label}
                </label>

                <input
                  type={
                    name.includes("password") ? "password" : "text"
                  }
                  name={name}
                  value={form[name]}
                  onChange={handleChange}
                  placeholder={placeholder}
                  className="border rounded-md px-4 py-2 w-full"
                />
              </div>
            ))}

            {/* USER TYPE */}
            <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-4 mb-4 items-center">
              <label className="text-sm font-medium text-gray-700 md:text-right">
                User Type
              </label>

              <select
                name="userType"
                value={form.userType}
                onChange={handleChange}
                className="border rounded-md px-4 py-2 w-full"
              >
                <option value="">Select User Type</option>
                <option value="FARMER">Farmer</option>
                <option value="VETERINARIAN">Veterinarian</option>
                <option value="ORGANIZATION">Organization</option>
                <option value="SUPERVISOR">Supervisor</option>
              </select>
            </div>

            {/* TEMPLATE */}
            <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-4 mb-10 items-center">
              <label className="text-sm font-medium text-gray-700 md:text-right">
                Template
              </label>

              <select
                name="template"
                value={form.template}
                onChange={handleChange}
                className="border rounded-md px-4 py-2 w-full"
              >
               

                <option value="">Select Template</option>
              {[...Array(10)].map((_, i) => (
                <option key={i + 1} value={` ${i + 1}`}>
                  {i + 1}
                </option>
              ))}
              </select>
            </div>

            {/* ACTION BUTTONS */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => navigate("/all-users")}
                className="border px-6 py-2 rounded-md"
              >
                Cancel
              </button>

              <button
                onClick={handleNext}
                className="bg-green-500 hover:bg-green-600 text-white px-8 py-2 rounded-md"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
